import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  AuthActions,
  AuthStorageService,
  AuthToken,
  OCC_USER_ID_CURRENT,
  RoutingService,
  UserIdService,
} from '@spartacus/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { UnifyRedirectService } from '../unify-redirect.service';

@Component({
  selector: 'app-unify-redirect',
  templateUrl: './unify-redirect.component.html',
  styleUrls: ['./unify-redirect.component.scss'],
})
export class UnifyRedirectComponent implements OnInit, OnDestroy {
  routeSub: Subscription;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly authStorageService: AuthStorageService,
    private readonly userIdService: UserIdService,
    private readonly store: Store,
    private readonly routing: RoutingService,
    private readonly unifyService: UnifyRedirectService
  ) {}

  busy$ = new BehaviorSubject(true);
  ngOnInit(): void {
    this.routeSub = this.activatedRoute.queryParams
      .pipe(
        switchMap((params) => {
          return this.unifyService.authenticateUser(params['token']).pipe(
            tap((data: any) => {
              if (data.access_token) {
                this.authStorageService.setToken({
                  access_token: data.access_token,
                  token_type: data.token_type,
                } as AuthToken);
                this.userIdService.setUserId(OCC_USER_ID_CURRENT);
                this.store.dispatch(new AuthActions.Login());

                this.busy$.next(false);
                this.routing.go('/');
              }
            })
          );
        })
      )
      .subscribe();
  }
  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }
}
